import React, { useState } from 'react';
import './review.scss';
import Previous from '../../assets/lessthan.svg';
import Next from '../../assets/morethan.svg';

export default function ReviewCarousel({ currentStep }) {
  const items = {
    personalItem: [
      `Hi, my name is Maria and I'm 28 years old. I'm currently living in Berlin with my husband and our two cats, Simon and Mimi. I was born and raised in Madrid, but I've also lived in New York and Sydney for a while. I have a background in marketing, but I'm currently working as a freelance writer and content creator. In my free time, I enjoy reading, traveling, and trying out new recipes in the kitchen.`,
      `Hi, my name is Alex and I'm 35 years old. I'm currently living in Toronto with my wife and our two young children, Jack and Emma. I was born and raised in Montreal, but I've also lived in London and Sydney for a while. I have a background in finance, but I'm currently working as a startup founder and CEO. I'm passionate about using technology to solve problems and make a positive impact on the world. In my free time, I enjoy playing sports, spending time with my family, and reading business and personal development books.`,
      `Hi, my name is Sarah and I'm 40 years old. I'm currently living in New York with my husband and our rescue dog, Charlie. I was born and raised in Chicago, but I've also lived in Paris and Barcelona for a while. I have a background in art history, but I'm currently working as a museum curator and art critic. I'm passionate about sharing my love of art with others and promoting cultural understanding. In my free time, I enjoy visiting galleries and museums, traveling, and practicing yoga. `,
    ],
    professionalTrainItem: [
      `I am an individual entrepreneur and social media consultant who helps small businesses and bloggers grow their online presence and reach their target audience. With over 10 years of experience in the industry, I have a deep understanding of social media algorithms and strategies and can help you create a cohesive and effective social media plan. I believe in the power of authenticity and the importance of building genuine relationships with your followers, and I strive to help my clients create a meaningful and engaging online presence.`,
      `Lead Generator is an AI tool that helps marketers craft personalized emails, social media posts, and landing pages. By analyzing your target audience's demographics, interests, and behaviors, Lead Generator creates custom marketing materials that resonate with them. It's an easy-to-use tool that can save you time and help you reach more leads and drive conversions. Simply input your information and let Lead Generator do the rest.`,
      `We are a web design agency that specializes in creating beautiful, user-friendly websites that help businesses and organizations achieve their online goals. Our team of experienced designers and developers have a passion for creating visually stunning and functional websites that are tailored to our clients' needs and target audience. We believe in the power of good design and the importance of a strong online presence, and we strive to create websites that are visually appealing and user-friendly.`,
    ],
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const updateActiveIndex = (newIndx) => {
    if (newIndx < 0) newIndx = 0;
    else if (newIndx >= items.personalItem.length) {
      newIndx = items.personalItem.length - 1;
    }
    setActiveIndex(newIndx);
  };
  return (
    <div className="carousel">
      <div className="title">EXAMPLES</div>

      <div className="previous" onClick={() => updateActiveIndex(activeIndex - 1)}>
        <img
          src={Previous}
          alt=""
          style={{
            opacity: activeIndex === 0 ? 0.5 : 1,
            cursor: activeIndex === 0 ? 'not-allowed' : 'pointer',
          }}
        />
      </div>

      <div className="next" onClick={() => updateActiveIndex(activeIndex + 1)}>
        <img
          src={Next}
          alt=""
          style={{
            opacity: activeIndex === 2 ? 0.5 : 1,
            cursor: activeIndex === 2 ? 'not-allowed' : 'pointer',
          }}
        />
      </div>

      <div className="inner" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
        {currentStep === 1
          ? items.personalItem.map((item, idx) => (
              <div key={idx} className="item">
                {item}
              </div>
            ))
          : items.professionalTrainItem.map((item, idx) => (
              <div key={idx} className="item">
                {item}
              </div>
            ))}
      </div>
    </div>
  );
}
